import { useMemo } from 'react';
import { MButton } from '@Components/Base';
import { Modal } from 'antd';

import styles from './material-modal.module.css';

interface MaterialAddModalProps {
  title: string;
  okText: string;
  modalOpen: boolean;
  isDisableSaveButton: boolean;
  handleOk: () => void;
  handleCancel: () => void;
  ModalContent: JSX.Element;
}

const MaterialAddModal: React.FC<MaterialAddModalProps> = ({
  title,
  okText,
  ModalContent,
  modalOpen,
  isDisableSaveButton,
  handleCancel,
  handleOk,
}) => {
  const customButtons = useMemo(
    () => [
      <MButton key="back" type="tertiary" onClick={handleCancel}>
        Cancel
      </MButton>,
      <MButton
        key="submit"
        type="primary"
        onClick={handleOk}
        disabled={isDisableSaveButton}
      >
        {okText}
      </MButton>,
    ],
    [isDisableSaveButton, handleOk, handleCancel]
  );

  return (
    <Modal
      className={styles.materialModal}
      title={title}
      open={modalOpen}
      onOk={handleOk}
      okText={okText}
      onCancel={handleCancel}
      style={{ height: '670px' }}
      width={600}
      footer={customButtons}
    >
      {ModalContent}
    </Modal>
  );
};

export default MaterialAddModal;
